import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { fetchRegistersMonitoredObject } from '../../../../../../state/app/registers/monitoredObjects';

import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import { useToolkitDispatch } from '../../../../../../hooks';

import { useStyles } from '../../Themable.hooks';

import { IEditObjectDialogFormValues, IHeaderData } from '../../types';

import { CustomToggleButtonGroup } from '../../../../../Styled/StyledToggleButtonGroup';
import ToggleButtonWithError from '../../../../../ToggleButtonWithError';
import EditObjectDataForm from '../EditObjectDataForm';
import AttributesForm from '../../../../../../features/Attributes/components/AttributesForm';
import LoadingSpinner from '../../../../../loadingSpinner/LoadingSpinner';
import { FormikErrors } from 'formik';
import { restGetAttributes } from '../../../../../../features/Attributes/services';
import { mapArrayToDictionary } from '../../../../../../helpers/mapToDictionary';
import { prepareAttributesFormData } from '../../../../../../features/Attributes/utils';

interface IOwnProps {
    headerData: IHeaderData;
    formValues: IEditObjectDialogFormValues;
    errors: FormikErrors<IEditObjectDialogFormValues>;
    setFieldValue: (fieldname: string, v: any) => void;
    loading: boolean;
    setLoading: (bool: boolean) => void;
}

const EditObjectForm = ({
    headerData,
    formValues,
    errors,
    setFieldValue,
    setLoading,
    loading,
}: IOwnProps) => {
    const [alignment, setAlignment] = useState<'data' | 'attributes'>('data');
    const { objectId, type } = headerData;

    const classes = useStyles();
    const toolkitDispatch = useToolkitDispatch();

    useEffect(() => {
        if (alignment === 'data' && errors.attributes && !errors.data) {
            setAlignment('attributes');
        }
        if (alignment === 'attributes' && errors.data && !errors.attributes) {
            setAlignment('data');
        }
    }, [errors]);

    useEffect(() => {
        setLoading(true);
        if (objectId && type) {
            const promises: Promise<any>[] = [
                toolkitDispatch(fetchRegistersMonitoredObject(objectId)),
                restGetAttributes(type),
            ];
            Promise.all(promises).then((data) => {
                const { fuelConsumptionWork, fuelConsumption } =
                    data[0].payload;

                setFieldValue('data', {
                    ...formValues.data,
                    ...data[0].payload,
                    fuelConsumptionType: fuelConsumptionWork ? 'mth' : 'km',
                    fuelConsumption:
                        fuelConsumptionWork || fuelConsumption || 0,
                });
                const dataAttributes = mapArrayToDictionary(
                    data[0].payload.registryAttributes,
                    'name',
                    'value'
                );

                const attributes = prepareAttributesFormData(
                    data[1],
                    type,
                    dataAttributes
                );
                setFieldValue('attributes', attributes);
                setLoading(false);
            });
        }
    }, [objectId]);

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: 'data' | 'attributes'
    ) => {
        if (newAlignment !== null) {
            setAlignment(newAlignment);
        }
    };
    if (loading) {
        return (
            <div className={classes.spinner}>
                <LoadingSpinner progressSize="8em" />
            </div>
        );
    }
    return (
        <>
            <CustomToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleChange}
                aria-label={TranslationHelper.translate('Choose section')}
                fullWidth
                size="medium"
            >
                <ToggleButtonWithError
                    value="data"
                    labelKey="Data"
                    hasError={!isEmpty(errors.data)}
                />

                <ToggleButtonWithError
                    value="attributes"
                    labelKey="Attributes"
                    hasError={!isEmpty(errors.attributes)}
                />
            </CustomToggleButtonGroup>
            {alignment === 'data' && (
                <EditObjectDataForm
                    headerData={headerData}
                    errors={errors.data || {}}
                    values={formValues.data}
                    setFieldValue={setFieldValue}
                />
            )}
            {alignment === 'attributes' && (
                <AttributesForm
                    errors={errors.attributes}
                    attributes={formValues.attributes}
                    setFieldValue={setFieldValue}
                />
            )}
        </>
    );
};

export default EditObjectForm;
